import { useEffect, useState } from 'react';
import Link from 'next/link';

import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreContextValue } from 'lib/ComponentProps';

import ChevronLeft from 'public/icons/ChevronLeft.svg';

import styles from './_BackToSearch.module.css';

export function BackToSearch(): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const [referredFromSearch, setReferredFromSearch] = useState(false);

	useEffect(() => {
		setReferredFromSearch(
			`${sitecoreContext.referer}`.split('?')[0].endsWith(window.location.host + process.env.NEXT_PUBLIC_DEFAULT_SEARCH_PATH) ? true : false
		);
	}, [sitecoreContext.referer]);

	return referredFromSearch ? (
		<div className="maxWidth padX">
			<Link href={`${sitecoreContext.referer}`}>
				<a className={`${styles.link} link linkOffset linkHoverWeighted`}>
					<ChevronLeft className={styles.icon} />

					<span className={styles.text}>Back to search results</span>
				</a>
			</Link>
		</div>
	) : (
		<></>
	);
}
